// Two of a practice's sections in the Settings dialog. "staff": the practice's staff, then one
// person's roles and exceptions there. "roles": what each role can do at the practice. Every rule
// is enforced by the server too; the screen only avoids offering what would be refused.
app.component("practiceStaffConsole", {
	templateUrl: "app/src/js/components/permissions/practiceStaffConsole.html",
	controller: "practiceStaffConsoleController",
	bindings: {
		practiceId: "<",
		section: "@",
		// Optional: { userId } opens the staff section on that person, { role } the roles section on that role.
		focus: "<",
	},
});

app.controller("practiceStaffConsoleController", [
	"$q",
	"$scope",
	"$window",
	"PermissionAPI",
	"Session",
	"USER_ROLE",
	"toast",
	function ($q, $scope, $window, PermissionAPI, Session, USER_ROLE, toast) {
		var $ctrl = this;
		var practiceId;

		// The CatTrax admin role belongs to CatTrax staff, not to a practice.
		$ctrl.roleOptions = USER_ROLE.filter(function (role) {
			return role.id !== "ADMIN";
		});
		$ctrl.staff = [];
		// An object, so the search box inside the ng-if blocks writes to this controller rather than its own scope.
		$ctrl.search = { text: "" };
		$ctrl.isProcessing = true;

		$ctrl.$onInit = function () {
			// The settings dialog can be pointed at any practice the user belongs to.
			practiceId = $ctrl.practiceId || (Session.practice && Session.practice.id);
			var practice = (Session.practiceOptions || []).find(function (option) {
				return option.id === practiceId;
			}) || Session.practice || {};
			$ctrl.practiceName = practice.name || "";
			$ctrl.canViewStaff = Session.hasPermissionAt(practice, "PRACTICE_USER_VIEW");
			$ctrl.canManageStaff = Session.hasPermissionAt(practice, "PRACTICE_USER_MANAGE");
			$ctrl.canManageRoles = Session.hasPermissionAt(practice, "PRACTICE_ROLE_MANAGE");
			if (!practiceId) {
				return;
			}
			var loads = [PermissionAPI.getCatalogue().then(function (response) {
				$ctrl.catalogue = response.data;
			})];
			if ($ctrl.canViewStaff) {
				loads.push(PermissionAPI.getStaff(practiceId).then(function (response) {
					$ctrl.staff = response.data.sort(byName);
				}));
			}
			if ($ctrl.canManageRoles) {
				loads.push(PermissionAPI.getPracticeRoles(practiceId).then(function (response) {
					$ctrl.practiceRoles = response.data;
				}));
			}
			$q.all(loads)
				.then(openFirstSection)
				.catch(function (response) {
					toast.create({
						timeout: 8 * 1000,
						message: PermissionAPI.errorMessage(response, "Staff and permissions could not be loaded."),
						className: "alert-danger",
						dismissible: true,
					});
				})
				.finally(function () {
					$ctrl.isProcessing = false;
				});
		};

		$ctrl.isSignedInUser = function (member) {
			return !!Session.user && member.user_id === Session.user.id;
		};

		// Matches a name, email address or role, so "nurse" finds every nurse.
		$ctrl.matchesSearch = function (member) {
			var text = $ctrl.search.text.trim().toLowerCase();
			if (!text) {
				return true;
			}
			var roleLabels = member.roles.map($ctrl.roleLabel);
			return [member.first_name + " " + member.last_name, member.email]
				.concat(roleLabels)
				.some(function (value) {
					return (value || "").toLowerCase().indexOf(text) !== -1;
				});
		};

		$ctrl.roleLabel = function (roleId) {
			var role = USER_ROLE.find(function (option) {
				return option.id === roleId;
			});
			return role ? role.label : roleId;
		};

		// Roles: what everyone with a role can do here.

		$ctrl.selectRole = function (role) {
			$ctrl.person = null;
			$ctrl.saveStatus = null;
			$ctrl.role = role;
			$ctrl.roleSelected = toSelected(role.permissions);
			$ctrl.roleCatalogue = onlyAvailable(role.available_permissions);
		};

		$ctrl.resetRoleToCattraxDefault = function () {
			$ctrl.roleSelected = toSelected($ctrl.role.available_permissions);
		};

		// What saving the role would switch on and off, and who has the role, shown before saving.
		// The switches change roleSelected in place, so it is watched deeply.
		$scope.$watch(function () {
			return $ctrl.roleSelected;
		}, updateRoleSummary, true);

		function updateRoleSummary() {
			if (!$ctrl.role || !$ctrl.roleCatalogue) {
				$ctrl.roleSummary = null;
				return;
			}
			var switchedOn = [];
			var switchedOff = [];
			$ctrl.roleCatalogue.forEach(function (permission) {
				var wasOn = $ctrl.role.permissions.indexOf(permission.name) !== -1;
				var isOn = !!$ctrl.roleSelected[permission.name];
				if (isOn && !wasOn) {
					switchedOn.push(permission);
				} else if (wasOn && !isOn) {
					switchedOff.push(permission);
				}
			});
			$ctrl.roleSummary = switchedOn.length || switchedOff.length
				? { switchedOn: switchedOn, switchedOff: switchedOff, staff: staffWithRole($ctrl.role.role) }
				: null;
		}

		// Null when this user can't see the staff list, so the screen says "everyone with the role".
		function staffWithRole(roleId) {
			if (!$ctrl.canViewStaff) {
				return null;
			}
			return $ctrl.staff.filter(function (member) {
				return member.roles.indexOf(roleId) !== -1;
			});
		}

		$ctrl.saveRole = function () {
			var summary = $ctrl.roleSummary;
			if (summary && summary.switchedOff.length && !$window.confirm(removalWarning(summary))) {
				return;
			}
			startSaving();
			PermissionAPI.savePracticeRole(practiceId, $ctrl.role.role, fromSelected($ctrl.roleSelected))
				.then(function (response) {
					var index = $ctrl.practiceRoles.roles.indexOf($ctrl.role);
					$ctrl.practiceRoles.roles[index] = response.data;
					$ctrl.selectRole(response.data);
					$ctrl.saveStatus = "Saved";
				})
				.catch(saveFailed("The role could not be saved."))
				.finally(stopSaving);
		};

		$ctrl.staffNames = function (staff) {
			return staff.map(function (member) {
				return member.first_name + " " + member.last_name;
			}).join(", ");
		};

		function removalWarning(summary) {
			var who = summary.staff === null
				? "everyone with the " + $ctrl.roleLabel($ctrl.role.role) + " role"
				: summary.staff.length + " staff with the " + $ctrl.roleLabel($ctrl.role.role) + " role";
			var what = summary.switchedOff.map(function (permission) {
				return permission.label;
			}).join(", ");
			return "This takes away \"" + what + "\" from " + who + " at " + $ctrl.practiceName
				+ ", within a minute. Anyone who also gets it from another role or an exception keeps it. Continue?";
		}

		// Staff: one person's roles and their access here.

		$ctrl.selectPerson = function (member) {
			$ctrl.role = null;
			$ctrl.saveStatus = null;
			$ctrl.person = member;
			$ctrl.personRoles = toSelected(member.roles);
			$ctrl.roleChanges = null;
			$ctrl.access = null;
			if ($ctrl.canManageRoles) {
				PermissionAPI.getUserPermissions(practiceId, member.user_id)
					.then(function (response) {
						setAccess(response.data);
					})
					.catch(saveFailed("This person's access could not be loaded."));
			}
		};

		$ctrl.showAllStaff = function () {
			$ctrl.person = null;
			$ctrl.saveStatus = null;
		};

		// For someone who also works elsewhere, a change here applies at this practice only.
		$ctrl.canEditPersonRoles = function () {
			return $ctrl.canManageStaff;
		};

		// Clinical roles depend on a person's registration, and the manager role could make more
		// managers, so CatTrax sets those. The server refuses them too.
		$ctrl.isPracticeAssignable = function (roleId) {
			return roleId === "TECHNICIAN" || roleId === "PRACTICE_ADMIN";
		};

		$ctrl.canTickRole = function (roleId) {
			return $ctrl.canEditPersonRoles() && $ctrl.isPracticeAssignable(roleId);
		};

		// Shows what the person would gain or lose here if the ticked roles were saved, before saving.
		$ctrl.updateRoleChanges = function () {
			var wanted = wantedRoles();
			if (sameList(wanted, $ctrl.person.roles) || !$ctrl.catalogue) {
				$ctrl.roleChanges = null;
				return;
			}

			var before = permissionsFrom($ctrl.person.roles);
			var after = permissionsFrom(wanted);
			$ctrl.roleChanges = {
				gained: $ctrl.catalogue.filter(function (permission) {
					return after[permission.name] && !before[permission.name];
				}),
				lost: $ctrl.catalogue.filter(function (permission) {
					return before[permission.name] && !after[permission.name];
				}),
			};
		};

		// Without role management the practice's own role changes can't be read, so the preview
		// falls back to the defaults and says so.
		$ctrl.previewUsesDefaults = function () {
			return !$ctrl.practiceRoles;
		};

		$ctrl.isPaidFor = function (permission) {
			return !$ctrl.practiceRoles
				|| permission.features.length === 0
				|| permission.features.some(function (feature) {
					return $ctrl.practiceRoles.enabled_features.indexOf(feature) !== -1;
				});
		};

		$ctrl.featureLabel = function (permission) {
			return permission.features.map(function (feature) {
				return feature.toLowerCase().replace(/_/g, " ");
			}).join(" or ");
		};

		$ctrl.savePersonRoles = function () {
			var roles = wantedRoles();

			startSaving();
			PermissionAPI.saveStaffRoles(practiceId, $ctrl.person.user_id, roles)
				.then(function (response) {
					var index = $ctrl.staff.indexOf($ctrl.person);
					$ctrl.staff[index] = response.data;
					$ctrl.selectPerson(response.data);
					$ctrl.saveStatus = "Roles saved";
				})
				.catch(saveFailed("The roles could not be saved."))
				.finally(stopSaving);
		};

		$ctrl.hasException = function () {
			return $ctrl.access && !sameList($ctrl.access.permissions, $ctrl.access.role_permissions);
		};

		$ctrl.saveAccess = function () {
			saveAccess(fromSelected($ctrl.accessSelected), "Saved");
		};

		$ctrl.removeException = function () {
			saveAccess($ctrl.access.role_permissions, "Exception removed");
		};

		$ctrl.saveFlashClass = function () {
			return {
				saving: $ctrl.saveStatus === "Saving...",
				error: $ctrl.saveStatus && $ctrl.saveStatus.indexOf("Error") === 0,
			};
		};

		$ctrl.saveFlashIcon = function () {
			if ($ctrl.saveStatus === "Saving...") {
				return "fa-circle-o-notch fa-spin";
			}
			return $ctrl.saveStatus.indexOf("Error") === 0 ? "fa-exclamation-circle" : "fa-check-circle";
		};

		// Staff opens on the list of people; Role permissions on the first role.
		function openFirstSection() {
			var focus = $ctrl.focus || {};
			if ($ctrl.section === "staff" && focus.userId) {
				var member = $ctrl.staff.find(function (person) {
					return person.user_id === focus.userId;
				});
				if (member) {
					$ctrl.selectPerson(member);
				}
			}
			if ($ctrl.section === "roles" && $ctrl.practiceRoles && $ctrl.practiceRoles.roles.length) {
				var focusRole = $ctrl.practiceRoles.roles.find(function (role) {
					return role.role === focus.role;
				});
				$ctrl.selectRole(focusRole || $ctrl.practiceRoles.roles[0]);
			}
		}

		function saveAccess(permissions, message) {
			startSaving();
			PermissionAPI.saveUserPermissions(practiceId, $ctrl.person.user_id, permissions)
				.then(function (response) {
					setAccess(response.data);
					$ctrl.saveStatus = message;
				})
				.catch(saveFailed("The exception could not be saved."))
				.finally(stopSaving);
		}

		function setAccess(access) {
			$ctrl.access = access;
			$ctrl.accessSelected = toSelected(access.permissions);
			$ctrl.accessCatalogue = onlyAvailable(access.available_permissions);
			$ctrl.accessReasons = reasonsFor(access.roles);
			$ctrl.updateRoleChanges();
		}

		function wantedRoles() {
			var roles = $ctrl.roleOptions
				.map(function (role) {
					return role.id;
				})
				.filter(function (roleId) {
					return $ctrl.personRoles[roleId];
				});
			// Keep a CatTrax admin role the person already has; the server refuses to remove it.
			if ($ctrl.person.roles.indexOf("ADMIN") !== -1) {
				roles.push("ADMIN");
			}
			return roles;
		}

		// What the given roles would let the person do here, with their exception still applied.
		function permissionsFrom(roleIds) {
			var result = {};
			roleIds.forEach(function (roleId) {
				rolePermissions(roleId).forEach(function (name) {
					result[name] = true;
				});
			});

			if ($ctrl.access) {
				var fromRoles = $ctrl.access.role_permissions;
				var withException = $ctrl.access.permissions;
				withException.forEach(function (name) {
					if (fromRoles.indexOf(name) === -1) {
						result[name] = true;
					}
				});
				fromRoles.forEach(function (name) {
					if (withException.indexOf(name) === -1) {
						delete result[name];
					}
				});
			}
			return result;
		}

		// The role as this practice has it. The CatTrax admin role isn't listed for practices, and
		// nothing is listed without role management, so those use the defaults instead.
		function rolePermissions(roleId) {
			var atPractice = $ctrl.practiceRoles && $ctrl.practiceRoles.roles.find(function (role) {
				return role.role === roleId;
			});
			if (atPractice) {
				return atPractice.permissions;
			}
			return $ctrl.catalogue
				.filter(function (permission) {
					return permission.default_roles.indexOf(roleId) !== -1;
				})
				.map(function (permission) {
					return permission.name;
				});
		}

		// Which of the person's roles gives them each permission here, to answer "why can't Sam do this?".
		function reasonsFor(personRoles) {
			var reasons = {};
			($ctrl.catalogue || []).forEach(function (permission) {
				var theirRoles = $ctrl.practiceRoles.roles.filter(function (role) {
					return personRoles.indexOf(role.role) !== -1;
				});
				var from = labelsOfRolesWith(theirRoles, "permissions", permission.name);
				var switchedOffFor = labelsOfRolesWith(theirRoles, "available_permissions", permission.name);
				if (from.length) {
					reasons[permission.name] = "From " + from.join(", ");
				} else if (switchedOffFor.length) {
					reasons[permission.name] = "Switched off here for " + switchedOffFor.join(", ");
				} else {
					reasons[permission.name] = "No role gives this";
				}
			});
			return reasons;
		}

		function startSaving() {
			$ctrl.isProcessing = true;
			$ctrl.saveStatus = "Saving...";
		}

		function stopSaving() {
			$ctrl.isProcessing = false;
		}

		function saveFailed(fallback) {
			return function (response) {
				$ctrl.saveStatus = "Error: " + PermissionAPI.errorMessage(response, fallback);
			};
		}

		function byName(first, second) {
			return (first.last_name + " " + first.first_name).localeCompare(second.last_name + " " + second.first_name);
		}

		// listName is "permissions" (on at this practice) or "available_permissions" (made available by CatTrax).
		function labelsOfRolesWith(roles, listName, permissionName) {
			return roles
				.filter(function (role) {
					return role[listName].indexOf(permissionName) !== -1;
				})
				.map(function (role) {
					return $ctrl.roleLabel(role.role);
				});
		}

		// Anything CatTrax hasn't made available is left off the practice's screens altogether.
		function onlyAvailable(available) {
			return $ctrl.catalogue.filter(function (permission) {
				return available.indexOf(permission.name) !== -1;
			});
		}

		function toSelected(names) {
			var selected = {};
			names.forEach(function (name) {
				selected[name] = true;
			});
			return selected;
		}

		function fromSelected(selected) {
			return Object.keys(selected).filter(function (name) {
				return selected[name];
			});
		}

		function sameList(first, second) {
			return first.length === second.length && first.every(function (name) {
				return second.indexOf(name) !== -1;
			});
		}
	},
]);
